import React from 'react'
import ReactSVG from "react-svg"
import { Link } from "react-router-dom"

const RegisterResponseMessage = (props) => {

  const { registerResponse, showRegisterForm } = props

  const error = require("../../../static/svg/error.svg")
  const success = require("../../../static/svg/checkmark.svg")

  if (registerResponse.status === "success") {
    return (
      <div className="register-response-container">
        <div className="d-flex justify-content-center align-items-center pt-3">
          <ReactSVG src={success} className="success-svg" />
          <h5 className="success-message" >
            {registerResponse.message}
          </h5>
        </div>
        <br />
        <div className='register-response-note'>
          <strong>
            Note
          </strong>:
          It is possible that receiving the activation email may take some time. Check your spam/junk folder if you can&#8216;t find the activation email in your inbox or reach out to
          <a
            href={`mailto:${SUPPORT_EMAIL}`}>
            &nbsp;{SUPPORT_EMAIL}.
          </a>
        </div>
      </div >
    )
  }

  if (registerResponse.message === "User already exists!") {
    return (
      <div className="register-response-container">
        <div className="d-flex justify-content-center align-items-center pt-3">
          <ReactSVG src={error} className="error-svg" />
          <h5 className="register-error-message">
            You have already registered with Clearout! Please check your email
            to complete registration process.
          </h5>
        </div>
        <div className="forgot-password mt-2">
          <Link to={"/forgot_password"}>Forgot Password</Link> |{" "}
          <Link to={"/login"}>Login</Link>
        </div>
      </div>
    )
  }

  if (registerResponse.status === "failed") {
    if (registerResponse.message === 'Try once again to confirm you are not a bot') {
      registerResponse.message = 'Sign up denied, please try again after sometime or contact us on chat or mail us at us@clearout.io.'
    }
    return (
      <div className="register-response-container">
        <div className="d-flex justify-content-center align-items-center pt-3">
          <ReactSVG src={error} className="error-svg" />
          <h5 className="register-error-message">
            {registerResponse.message}
          </h5>
        </div>
        <div className="forgot-password">
          {
            registerResponse.message.includes('Your sign-up has been denied, probable violations of the Terms of Service.')
              ? null
              : <button
                className="register-link btn btn-link"
                onClick={showRegisterForm}
              >
                Register
              </button>
          }
        </div>
      </div>
    )
  }

  return null
}

export default RegisterResponseMessage
